/**
 * フィルム DB
 *
 * 中判で一般的に使用されるモノクロフィルムを中心に収録。
 * monoPreset は Canvas の RGB→グレー変換時のチャンネル重みのキー
 * (mono.js の FILM_PRESETS と対応)
 */

export const FILMS = [
  // === Kodak ===
  { id: 'tri-x-400',   brand: 'Kodak',   name: 'Tri-X 400',          iso: 400,  monoPreset: 'tri-x',         desc: 'パンクロ標準、シャドウ豊か' },
  { id: 'tmax-100',    brand: 'Kodak',   name: 'T-Max 100',          iso: 100,  monoPreset: 'tmax',          desc: '微粒子・高シャープ' },
  { id: 'tmax-400',    brand: 'Kodak',   name: 'T-Max 400',          iso: 400,  monoPreset: 'tmax',          desc: 'ニュートラル、現代的' },
  { id: 'tmax-3200',   brand: 'Kodak',   name: 'T-Max P3200',        iso: 3200, monoPreset: 'tmax',          desc: '高感度、暗所撮影' },
  { id: 'plus-x',      brand: 'Kodak',   name: 'Plus-X 125 (廃番)',  iso: 125,  monoPreset: 'panchromatic',  desc: 'クラシック中庸感' },

  // === Ilford ===
  { id: 'hp5-plus',    brand: 'Ilford',  name: 'HP5 Plus',           iso: 400,  monoPreset: 'hp5',           desc: '柔らかいハイライト、ラチチュード広' },
  { id: 'fp4-plus',    brand: 'Ilford',  name: 'FP4 Plus',           iso: 125,  monoPreset: 'panchromatic',  desc: '微粒子、安定したトーン' },
  { id: 'delta-100',   brand: 'Ilford',  name: 'Delta 100',          iso: 100,  monoPreset: 'tmax',          desc: '高解像度、モダン' },
  { id: 'delta-400',   brand: 'Ilford',  name: 'Delta 400',          iso: 400,  monoPreset: 'tmax',          desc: 'シャープ、コントラスト中' },
  { id: 'delta-3200',  brand: 'Ilford',  name: 'Delta 3200',         iso: 3200, monoPreset: 'tmax',          desc: '高感度、粒状感' },
  { id: 'pan-f-plus',  brand: 'Ilford',  name: 'Pan F Plus 50',      iso: 50,   monoPreset: 'panchromatic',  desc: '極微粒、低感度向き' },
  { id: 'sfx-200',     brand: 'Ilford',  name: 'SFX 200',            iso: 200,  monoPreset: 'sfx',           desc: '近赤外感度、特殊効果' },

  // === Fujifilm ===
  { id: 'acros-100-ii',brand: 'Fujifilm',name: 'Acros 100 II',       iso: 100,  monoPreset: 'acros',         desc: '滑らかなトーン、長時間露光に強い' },
  { id: 'neopan-400',  brand: 'Fujifilm',name: 'Neopan 400 (廃番)',  iso: 400,  monoPreset: 'panchromatic',  desc: 'クラシック日本製' },

  // === Foma ===
  { id: 'fomapan-100', brand: 'Foma',    name: 'Fomapan 100',        iso: 100,  monoPreset: 'panchromatic',  desc: 'コスパ良、クラシックトーン' },
  { id: 'fomapan-400', brand: 'Foma',    name: 'Fomapan 400',        iso: 400,  monoPreset: 'panchromatic',  desc: '粒状感あり、ヴィンテージ' },

  // === Adox ===
  { id: 'cms-20-ii',   brand: 'Adox',    name: 'CMS 20 II',          iso: 20,   monoPreset: 'tmax',          desc: '極めて高解像度' },
  { id: 'silvermax',   brand: 'Adox',    name: 'Silvermax 100',      iso: 100,  monoPreset: 'panchromatic',  desc: '銀リッチ、深い黒' },

  // === Bergger ===
  { id: 'pancro-400',  brand: 'Bergger', name: 'Pancro 400',         iso: 400,  monoPreset: 'panchromatic',  desc: 'デュアル感光乳剤、独特なトーン' },

  // === カラー（参考、モノクロ変換時のシミュレーション用） ===
  { id: 'portra-400',  brand: 'Kodak',   name: 'Portra 400',         iso: 400,  monoPreset: 'panchromatic',  desc: 'カラーネガ、モノクロ運用は変換扱い' },
  { id: 'velvia-50',   brand: 'Fujifilm',name: 'Velvia 50',          iso: 50,   monoPreset: 'panchromatic',  desc: 'カラーポジ、彩度高' },
  { id: 'ektar-100',   brand: 'Kodak',   name: 'Ektar 100',          iso: 100,  monoPreset: 'panchromatic',  desc: 'カラーネガ、彩度高' },
];

export function getFilmById(id) {
  return FILMS.find((f) => f.id === id);
}

export function getFilmsByBrand() {
  const map = new Map();
  FILMS.forEach((f) => {
    if (!map.has(f.brand)) map.set(f.brand, []);
    map.get(f.brand).push(f);
  });
  return map;
}
